// extracted by mini-css-extract-plugin
module.exports = {"customSelect":"newCar-select_customSelect__2X0jQ","formLabel":"newCar-select_formLabel__5nSiw","formInput":"newCar-select_formInput__tNyls"};